<div class="wrapper">
  <cst-toolbar>
    <ctrl-btn-create [matMenuTriggerFor]="menu"></ctrl-btn-create>
    <mat-menu #menu="matMenu">
      <button mat-menu-item (click)="onAddItemFromCatalogue()">
        From catalogue
      </button>
      <button mat-menu-item (click)="onAddCustomItem()">Custom item</button>
    </mat-menu>
  </cst-toolbar>
  <tab-formular-artikel-table [data]="{ data: artikel(), actions: itemActions }" #table>
  </tab-formular-artikel-table>
</div>